/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilIcon24Solid = forwardRef('ToolPencilIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.004 20.496V17.76c0-.398.158-.78.44-1.06l9.964-9.965 3.856 3.857L7.3 20.556a1.5 1.5 0 0 1-1.06.44H3.503a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "m18.648 9.208 1.757-1.757a1.75 1.75 0 0 0 0-2.475l-1.381-1.38a1.75 1.75 0 0 0-2.475 0l-1.757 1.756 3.856 3.856Z" })));
});
